export { default } from "./heading-menu-context";
